import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SafeHtmlPipe } from '../../../../pipes/safe-html.pipe';

@Component({
  selector: 'app-pop-up',
  standalone: true,
  imports: [SafeHtmlPipe],
  templateUrl: './pop-up.dialog.html',
  styleUrl: './pop-up.dialog.scss',
})
export class PopUpDialog {
  title?: string;
  description?: string;
  constructor(
    public dialogRef: MatDialogRef<PopUpDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.title = data.title;
      this.description = data.description;
    }
  }
  close(event?: any) {
    this.dialogRef.close(event);
  }
}
